<template>
  <div>
    <section class="subheader" style="background: #048042">
      <div class="container">
        <h2>التبرع</h2>
        <ul>
          <li><router-link to="/" href="#">الرئيسية</router-link></li>
          <li>المنظمة</li>
          <li>التبرع</li>
        </ul>
      </div>
    </section>

    <div class="container">
      <div v-if="loadingCampaigns && active_button == 1" class="mt-1">
        <div class="row">
          <b-skeleton type="button" class="mx-1 skeleton_tap"></b-skeleton>
          <b-skeleton type="button" class="mx-1 skeleton_tap"></b-skeleton>
          <b-skeleton type="button" class="mx-1 skeleton_tap"></b-skeleton>
        </div>
        <div class="mt-3" v-for="n in 3" :key="n">
          <b-skeleton animation="fade" width="20%"></b-skeleton>
          <b-skeleton
            v-for="n in 4"
            :key="n"
            animation="fade"
            width="85%"
          ></b-skeleton>
        </div>
      </div>

      <div v-if="loadingCampaigns && active_button !== 1">
        <div class="row my-1">
          <b-skeleton type="button" class="mx-1 skeleton_tap"></b-skeleton>
          <b-skeleton type="button" class="mx-1 skeleton_tap"></b-skeleton>
          <b-skeleton type="button" class="mx-1 skeleton_tap"></b-skeleton>
        </div>
        <div class="row">
          <Skeleton
            class="col-lg-4 col-md-6 col-12"
            v-for="n in 3"
            :key="n"
          ></Skeleton>
        </div>
      </div>

      <div class="pupup" v-else>
        <div class="d-flex">
          <div
            class="button_tap mt-2"
            v-for="item in bitton_tap"
            :key="item.id"
            :class="{ active_button_tap: item.id == active_button }"
            @click="active_button = item.id"
          >
            {{ item.name }}
          </div>
        </div>
        <hr class="mt-0" />

        <div v-if="active_button == 1">
          <h4 class="my-3 font-weight-bolder">التبرع عن طريق الحساب البنكي</h4>
          <div class="row">
            <p class="col-md-12" style="text-align: justify">
              سنكون ممنونين باستقبال تبرعاتكم على أرقام الحسابات البنكية
              لمنظمتنا والمخصصة لجمع التبرعات الموضحة في الجدول التالي
            </p>
            <data-table
              class="col-md-12 border py-1"
              :ep="`/v2/guest/bank-accounts/${$route.params.id}`"
              :fields="bankTable"
              hidePageSize
            />
          </div>

          <h4 class="my-3 font-weight-bolder">
            التبرع عن طريق زيارة أحد مراكزنا
          </h4>
          <div class="row">
            <p class="col-md-12" style="text-align: justify">
              ونتشرف أيضاً بزيارتكم ضمن مراكزنا وتقديم التبرعات العينية او
              المالية والإطلاع على برامجنا وخدماتنا من خلال زيارة مراكزنا
              الموضحة أدناه
            </p>
            <data-table
              class="col-md-12 border py-1"
              :ep="`/v2/guest/service-centres/${$route.params.id}`"
              :fields="centresTable"
              hidePageSize
            />
          </div>

          <h4 class="my-3 font-weight-bolder">
            التبرع عن طريق زيارة أحد فروعنا
          </h4>
          <div class="row">
            <p class="col-md-12" style="text-align: justify">
              ونتشرف أيضاً بزيارتكم ضمن فروعنا وتقديم التبرعات العينية او
              المالية والإطلاع على برامجنا وخدماتنا من خلال زيارة فروعنا
              الموضحة أدناه
            </p>

            <data-table
              class="col-md-12 border py-1 my-2"
              :ep="`/v2/guest/branches/${$route.params.id}`"
              :fields="branchesTable"
              hidePageSize
            />
          </div>
          <div v-show="availableMethods.length > 0">
            <h4 class="my-3 font-weight-bolder">
              التبرع عن طريق التبرع الالكتروني
            </h4>
            <guest-epayment ref="paymentMethods" />
          </div>

          <h4 class="my-3 font-weight-bolder">التبرع الخارجي</h4>
          <p class="mb-4" style="text-align: justify">
            للراغبين بالتبرع من الخارج لاغراض الاغاثة ومتضرري الزلزال يمكن تحويل
            اي مبالغ الى حسابات المنظمات المتوفرة على المنصة الوطنية للمنظمات
            غير الحكومية "تشارك" عن طريق المصارف وشركات الصرافة وشبكات التحويل
            المصرفية العالمية (ويسترن يونيون) والسفارات والقنصليات السورية وذلك
            وفق الترخيص ٢٣ الصادر عن مكتب مراقبة الأصول الاجنبية التابع لوزارة
            الخزانة الامريكية.
          </p>
        </div>
        <div v-if="active_button == 2">
          <div class="row">
            <div
              class="col-lg-4 col-md-6 col-12"
              v-for="item in campaigns"
              :key="item.id"
            >
              <card-donation :item="item" />
            </div>
            <Alert
              v-if="campaigns.length == 0"
              class="col-lg-12 mt-1 mb-5 w-100"
              :massage="$t('alert')"
              style="height: 40px"
            ></Alert>
          </div>
          <pagination
            v-if="pagination.total_row != 0"
            v-model="currentPage"
            :total-rows="pagination.total_row"
            :per-page="pagination.per_page"
            align="center"
          >
          </pagination>
        </div>

        <div v-if="active_button == 3">
          <div class="row">
            <div
              class="col-lg-4 col-md-6 col-12"
              v-for="item in campaigns"
              :key="item.id"
            >
              <card-donation :item="item" />
            </div>
            <Alert
              v-if="campaigns.length == 0"
              class="col-lg-12 mt-1 mb-5 w-100"
              :massage="$t('alert')"
              style="height: 40px"
            ></Alert>
          </div>

          <pagination
            v-if="pagination.total_row != 0"
            v-model="currentPage"
            :total-rows="pagination.total_row"
            :per-page="pagination.per_page"
            align="center"
          >
          </pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BTable, BNav, BNavItem } from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";
import { BSpinner, BButton, BPaginationNav } from "bootstrap-vue";
import { BTabs, BTab, BCardText, BSkeleton } from "bootstrap-vue";
import Alert from "../../../../components/Alert.vue";
import CardDonation from "../../components/CardDonation.vue";
import Skeleton from "../../components/Skeleton.vue";
import Pagination from "@/components/pagination/index.vue";
import DataTable from "@/components/data-table";
import GuestEpayment from "../../components/GuestEpayment.vue";

export default {
  components: {
    BTable,
    BNav,
    BNavItem,
    BSpinner,
    BTabs,
    BTab,
    BCardText,
    Alert,
    CardDonation,
    Pagination,
    BButton,
    Skeleton,
    BPaginationNav,
    BSkeleton,
    DataTable,
    GuestEpayment,
  },
  data() {
    return {
      currentPage: 1,
      bitton_tap: [
        { name: "طرق التبرع", id: 1 },
        { name: "حملات التبرع", id: 2 },
        { name: "حملات التبرع السابقة", id: 3 },
      ],
      active_button: 1,
      centresTable: [
        { key: "name", label: "اسم المركز" },
        { key: "clearanceAuthority.name_ar", label: "المحافظة" },
        { key: "address", label: "العنوان" },
      ],
      branchesTable: [
        { key: "info.name_ar", label: "الفرع / المكتب" },
        { key: "info.address", label: "العنوان" },
      ],
      bankTable: [
        { key: "bank.name_ar", label: "اسم البنك" },
        { key: "branch_name", label: "اسم الفرع" },
        { key: "account_no", label: "رقم الحساب" },
      ],
    };
  },
  computed: {
    ...mapGetters("NgoHome/donationNgo", [
      "loadingCampaigns",
      "campaigns",
      "pagination",
      "availableMethods",
    ]),
  },
  methods: {
    isPaymentUnavailable() {
      return (
        !this.$refs.paymentMethods.checkMethodAvailability("SYRIATEL") &&
        !this.$refs.paymentMethods.checkMethodAvailability("MTN") &&
        !this.$refs.paymentMethods.checkMethodAvailability("FATORA")
      );
    },

    submitEvent() {
      if (this.active_button == 2) {
        this.$store.dispatch(`NgoHome/donationNgo/getCampaigns`, {
          type: "active",
          id: this.$route.params.id,
          page: this.currentPage,
        });
      } else if (this.active_button == 3) {
        this.$store.dispatch(`NgoHome/donationNgo/getCampaigns`, {
          type: "inactive",
          id: this.$route.params.id,
          page: this.currentPage,
        });
      }
    },
  },

  watch: {
    currentPage(value) {
      this.$store.dispatch(`NgoHome/donationNgo/getCampaigns`, {
        type: this.active_button == 2 ? "active" : "inactive",
        id: this.$route.params.id,
        page: value,
      });
    },
    active_button() {
      this.submitEvent();
    },
  },
};
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/horizontal-menu.scss";

.h3-logo-row .h3-logo {
  padding: 2px !important;
  // text-align: justify;
}

.skeleton_tap {
  width: 150px;
}
@media (max-width: 648px) {
  .skeleton_tap {
    width: 75px;
  }
  .button_tap {
    font-size: 9px;
    width: 30%;
  }
}
.pupup {
  min-height: 500px;

  .button_tap {
    border: 1px solid #048042;
    padding-top: 7px;
    padding-bottom: 7px;
    max-width: 150px;
    cursor: pointer;
    padding-left: 10px;
    padding-right: 10px;
    text-align: center;
    transition: all 0.3s ease;

    &:hover {
      background: #0e569642;
    }
  }
  .active_button_tap {
    background: #048042;
    color: #eee;
    transition: all 0.3s ease;
  }
}
</style>
